import type {CellType} from '@PosterWhiteboard/items/layouts/cells/cell.types';

export type TableDataType = string | CellData | TimeData | DateData;

export enum DateFormat {
  FORMAT_1 = 'm-d',
  FORMAT_2 = 'd-m',
  FORMAT_3 = 'm-d-y',
  FORMAT_4 = 'm-d-Y',
  FORMAT_5 = 'd-m-y',
  FORMAT_6 = 'M d',
  FORMAT_7 = 'l j F',
  FORMAT_8 = 'l j F Y',
}

export enum TimeFormat {
  STANDARD = '12-h',
  MILITARY = '24-h',
  DISABLE = 'Disable',
}

export enum TimeMeridiem {
  AM = 'AM',
  PM = 'PM',
}

export enum DefaultTime {
  HOURS = '12',
  MINUTES = '00',
}

export interface TimeData {
  hours: string;
  minutes: string;
  meridiem: string;
  timeFormat: TimeFormat;
  type: CellType.TIME;
}

export interface DateData {
  timestamp: string;
  dateFormat: DateFormat;
  type: CellType.DATE;
}

export interface CellData {
  value: string;
  type: CellType.TEAM | CellType.VENUE;
}
